import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { SkeletonBasicModule } from '@epicuro-next/ataraxia/skeleton-basic';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';

import { CarouselCardComponent } from './card/carousel-card.component';
import { CarouselSlideDirective } from './carousel-slide.directive';
import { CarouselComponent } from './carousel/carousel.component';
import { ImagePreloadDirective } from './image-preload.directive';

/**
 * Module declarations that are meant to be used outside of this module
 */
const PUBLIC_DECLARATIONS = [
  CarouselCardComponent,
  CarouselComponent,
  CarouselSlideDirective,
];
@NgModule({
  declarations: [
    ...PUBLIC_DECLARATIONS,
    ImagePreloadDirective,
    CarouselSlideDirective,
  ],
  imports: [
    CommonModule,
    IconsModule,
    ImageModule,
    TooltipDirective,
    SkeletonBasicModule,
  ],
  exports: [...PUBLIC_DECLARATIONS],
})
export class CarouselModule {}
